import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ChatPanel from '../components/ChatPanel';
import WorkingArea from '../components/WorkingArea';
import HoldingsModal from '../components/HoldingsModal';
import { useAdvisor } from '../context/AdvisorContext';
import './Advisor.css';

export default function Strategy() {
  const { params } = useAdvisor();
  const navigate = useNavigate();

  // If no strategy exists yet, bounce back to the advisor chat
  useEffect(() => {
    if (params === null) navigate('/', { replace: true });
  }, [params, navigate]);

  if (!params) return null;

  return (
    <div className="advisor">
      <div className="working-area">
        <WorkingArea />
        {/* Modal renders INSIDE the working area so it centers within the
            backtest content (not the viewport) and the chat panel stays
            visible while the modal is open. */}
        <HoldingsModal />
      </div>
      <ChatPanel />
    </div>
  );
}
